import 'jquery';
import ds from 'Shared/ds';

class FormApi {

   static handleErrors = ($form, errors) => {
        var validator = $form.validate();

        $.each(errors, function (field, error) {
            if (field === "") {
                $form.find(".validation-summary-valid")
                    .html('<div class="alert alert-danger"><span>' + error + "</span></div>");
            } else {
                var list = {};
                list[field] = error;

                validator.showErrors(list);
            }
        });
    }

    static submitAjax = (form, url) => {
        var $form = $(form);
        if ($form.valid()) {
            url = url || $form.attr("action");

            var data = $form.serialize();

            return ds.post(url, data)
                .then(result => {
                    var t = $.Deferred();
                    if (!result.Success) {
                        this.handleErrors($form, result.Errors);
                        return t.reject();
                    }

                    return t.resolve(result);
                })
                .fail(xhr => {
                    if (xhr && xhr.status === 400) {
                        this.handleErrors($form, $.parseJSON(xhr.responseText));
                    }
                });
        }
    }

    static validate = (form) => {
        return $(form).valid();
    }

    static Events = () => this.Events
}



export default FormApi;
